module.exports = __webpack_public_path__ + "img/logo.b510520a.png";